import gql from 'graphql-tag';

export const UPSERT_SIGNUP_INFO_M = gql`
  mutation UpsertSignupInfoMutation (
    $userId: UUID!
    $phone: String!
    $roleId: Float!
    $otherRole: String
    $industryId: Float!
    $otherIndustry: String
    $companySizeId: Float
    $actualCompanySize: Float
    $regionId: Float!
    $subRegionId: Float
    $fromId: Float
    $otherFrom: String
    $hasSkip: Boolean
  ) {
    upsertSignupInfo(
      upsertSignupInfoDTO: {
        userId: $userId
        phone: $phone
        roleId: $roleId
        otherRole: $otherRole
        industryId: $industryId
        otherIndustry: $otherIndustry
        companySizeId: $companySizeId
        actualCompanySize: $actualCompanySize
        regionId: $regionId
        subRegionId: $subRegionId
        fromId: $fromId
        otherFrom: $otherFrom
        hasSkip: $hasSkip
      }
    ) {
      code
      success
      message
    }
  }
`;